import { FormControlLabel, Checkbox } from "@mui/material";
import { Controller } from "react-hook-form";
import { UseFormReturn } from "react-hook-form";
import { AvailabilityPreferences, AvailabilitySlot } from "../../utils/types";

type ConsecutiveSessionsProps = {
    entityForm: UseFormReturn<AvailabilityPreferences>;
    setSelectedSlots: (slots: AvailabilitySlot[]) => void;
};

export const ConsecutiveSessions = ({ entityForm, setSelectedSlots }: ConsecutiveSessionsProps) => {
    const { control } = entityForm;
    return (
        <Controller
            name="requireConsecutiveSessions"
            control={control}
            render={({ field }) => (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={field.value}
                            onChange={(e) => {
                                setSelectedSlots([]);
                                field.onChange(e.target.checked);
                            }}
                        />
                    }
                    label="Sessões consecutivas"
                />
            )}
        />
    );
};
